var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page"},[_c('section',[_c('TextComponent',[_c('h3',[_vm._v(_vm._s(_vm._f("translate")('hangYourBirthPoster')))]),_vm._v(" "),_c('h2',[_vm._v(_vm._s(_vm._f("translate")('framesTitle')))]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm._f("translate")('framesParagraphOne')))]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm._f("translate")('framesParagraphTwo')))])])],1),_vm._v(" "),_c('section',[_c('Frames',{attrs:{"frames":_vm.frames}})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-06b23efa","hasScoped":false,"buble":{"transforms":{}}}!./src/pages/frames/template.html
// module id = 989
// module chunks = 0